import React from 'react';
import { UsersIcon } from 'lucide-react';
import { Countdown } from './Countdown';
export function ScarcityBlock() {
  return <div className="mx-auto w-full max-w-xl rounded-2xl border border-alert/30 bg-surface p-5 sm:p-6" data-id="element-217" data-mp="3aogxmauj275t">
      <Countdown data-id="element-218" data-mp="2wxty4ggy0d8o" />

      <div className="mt-6 border-t border-line pt-5" data-id="element-219" data-mp="2wu64zifetsuh">
        <div className="flex items-center justify-between gap-3" data-id="element-220" data-mp="31wf0alfr96zr">
          <span className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.14em] text-white" data-id="element-221" data-mp="3pky5gs3id3nm">
            <UsersIcon className="h-4 w-4 text-alert" aria-hidden="true" data-id="element-222" data-mp="3tn1kfqpdyqdn" />
            Plus que 13 accès
          </span>
          <span className="text-[12px] font-bold text-alert" data-id="element-223" data-mp="3flp7zp9fp6wi">94 % réclamé</span>
        </div>

        <div className="mt-3 h-3 w-full overflow-hidden rounded-full bg-ink" role="progressbar" aria-valuenow={94} aria-valuemin={0} aria-valuemax={100} aria-label="Accès promotionnels déjà réclamés" data-id="element-224" data-mp="3kksbv6doh72w">
          <div className="h-full w-[94%] rounded-full bg-alert" data-id="element-225" data-mp="1usjh0wy1j9nz" />
        </div>

        <p className="mt-3 text-center text-[13px] leading-relaxed text-slate-400" data-id="element-226" data-mp="1uumg06h68d4u">
          Seuls <strong className="text-white" data-id="element-227" data-mp="1qtaqs227ltx6">13 accès</strong> restent disponibles au prix
          promotionnel de 19 €. Une fois ce nombre atteint, le prix reviendra à 97 €.
        </p>
      </div>
    </div>;
}